var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.fields)?_c('div',{staticClass:"item"},_vm._l((_vm.metadata.rows),function(row,i){return _c('div',{key:i,staticClass:"item-row"},_vm._l((row.fields),function({ name }){return _c('form-row',{key:name,staticClass:"address-item",attrs:{"rules":_vm.rules[`${_vm.item.id}__${name}`],"prop":`${_vm.item.id}__${name}`,"field":{
        ..._vm.schema[name],
        ..._vm.dynamicParams(name, _vm.schema[name])
      },"options":_vm.defaultOptions(name, _vm.schema[name]),"model":_vm.getField(name).value,"form":_vm.parentForm},on:{"set-value":(n, val) =>
          _vm.handleChange({
            [`${_vm.item.id}__${name}`]: val
          }),"change-option":_vm.changeOption,"change-rellink-option":_vm.changeRellinkOption}})}),1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }